import type {
  Migration,
  MigrationInstallation
} from '@epilot/migrations-client'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { getMigrationClient } from '@/api/migrations-client'

const migrationClient = getMigrationClient()

export const MIGRATION_QUERY_IDS = {
  GET_INSTALLED_MIGRATIONS: 'GET_INSTALLED_MIGRATIONS',
  GET_AVAILABLE_MIGRATIONS: 'GET_AVAILABLE_MIGRATIONS'
}

export type { Migration, MigrationInstallation }

type UseQueryReturn<T> = ReturnType<typeof useQuery<T>>

export const useQueryGetInstalledMigrations = (
  orgId: string,
  opts: Partial<UseQueryOptions<MigrationInstallation[]>> = {}
): UseQueryReturn<MigrationInstallation[]> => {
  return useQuery<MigrationInstallation[]>({
    queryKey: [MIGRATION_QUERY_IDS.GET_INSTALLED_MIGRATIONS, orgId],
    queryFn: () =>
      migrationClient
        .getInstalledMigrations({}, {}, { headers: { 'x-ivy-org-id': orgId } })
        .then((res) => res.data),
    refetchOnWindowFocus: true,
    ...opts
  })
}

export const useQueryGetAvailableMigrations = (
  orgId: string,
  opts: Partial<UseQueryOptions<Migration[]>> = {}
): UseQueryReturn<Migration[]> => {
  return useQuery<Migration[]>({
    queryKey: [MIGRATION_QUERY_IDS.GET_AVAILABLE_MIGRATIONS, orgId],
    queryFn: () =>
      migrationClient
        .listMigrations({}, {}, { headers: { 'x-ivy-org-id': orgId } })
        .then((res) => res.data?.results ?? []),
    refetchOnWindowFocus: true,
    ...opts
  })
}
